import type { Icon } from '../../../src/lib/types'
export const mdiArrowDown: Icon = {
  "id": "arrow-down",
  "name": "Arrow Down",
  "path": "M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z",
  "as": [
    "arrow-downward",
    "arrow-bottom"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiArrowDown